import type { Category } from "../types";

export const CATEGORIES: Category[] = [
  "New Arrivals",
  "Best Sellers",
  "Tops",
  "Bottoms",
  "Outerwear",
  "Accessories",
];

export const SORT_OPTIONS = [
  { value: "featured", label: "Featured" },
  { value: "new", label: "Newest" },
  { value: "price-asc", label: "Price: Low to High" },
  { value: "price-desc", label: "Price: High to Low" },
] as const;

export type SortOption = (typeof SORT_OPTIONS)[number]["value"];
